// base urls :local,live,dev

export const Baseurl = {
  // nodeLocal: 'http://192.168.8.130:8000/',
  // nodeLocal: 'http://localhost:8000/',
  // nodeLocal: 'https://intranet.inferenz.ai:8000/',
  // nodeLocal: 'https://devintranet.inferenz.ai:8001/',
  nodeLocal: 'https://qaintranet.inferenz.ai:8002/',
}
